/**
 * Project default constants.
 *
 * Use these instead of hardcoded 1920/1080/30 literals when falling back from
 * missing project metadata or initializing new projects.
 */

export const DEFAULT_PROJECT_WIDTH = 1920
export const DEFAULT_PROJECT_HEIGHT = 1080
export const DEFAULT_PROJECT_FPS = 30
/** Default canvas background blur amount (0–100) in 'blur' background mode. */
export const DEFAULT_BACKGROUND_BLUR = 40
